import { useEffect, useState } from 'react'
import { useAuthStore } from '../../../../stores/auth/useAuthStore'
import { useAuthHandlers } from '../../../../services/actions/auth/useAuthHandlers'

/**
 * The API key the viewer uses themselves: their own active member key when they have one
 * (admins included), otherwise the workspace key for the owner and admins. Loaded from
 * GET /auth/api-keys, since login and /auth/me do not carry keys. Null while loading or
 * when there is none.
 */
export const useOwnApiKey = () => {
    const { store: { user, workspace, workspaceOwner, workspaceAdmin } } = useAuthStore()
    const { getAPIKeysHandler } = useAuthHandlers()

    const [apiKey, setApiKey] = useState<string | null>(null)
    const isAdmin = workspaceOwner || workspaceAdmin

    useEffect(() => {
        let cancelled = false

        getAPIKeysHandler().then(result => {
            if (cancelled || !result) return
            // Admins get every member's key, so the viewer's own is picked by id.
            const ownKey = result.memberApiKeys.find(item => item.userId === user?._id && !item.revokedAt)?.key
            setApiKey(ownKey ?? (isAdmin ? result.apiKey : null))
        })

        return () => { cancelled = true }
    }, [workspace?._id, user?._id, isAdmin])

    return apiKey
}
